module.exports = __webpack_public_path__ + "img/c_5.22b5c79e.jpg";